import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PickFaceStrategyExcel01Actions, {
  PickFaceStrategyExcel01Types
} from '../Stores/PickFaceStrategyExcel01/Actions';

const getAppStore = state => state.app;

export function* pickFaceStrategyExcel01ShowBatchJobStatus() {
  try {
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `batchJobStatus/showBatchJobStatus/PICK_FACE_STRATEGY_EXCEL_01`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PickFaceStrategyExcel01Actions.pickFaceStrategyExcel01ShowBatchJobStatusSuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  }
}

export function* pickFaceStrategyExcel01UploadExcel({ file }) {
  try {
    yield put(PickFaceStrategyExcel01Actions.pickFaceStrategyExcel01UploadLoading(true));

    const app = yield select(getAppStore);

    // eslint-disable-next-line no-undef
    const postData = new FormData();
    postData.append('file', file);

    const getData = {};

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `pickFaceStrategy/uploadProcess/PICK_FACE_STRATEGY_EXCEL_01/${app.curSiteFlowId}`,
      app.token,
      postData,
      getData,
      'multipart/form-data'
    );

    if (result.isSuccess === true) {
      // result.data is total
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PickFaceStrategyExcel01Actions.pickFaceStrategyExcel01UploadLoading(false));
  }
}

export function* pickFaceStrategyExcel01DownloadExcel() {
  try {
    yield put(PickFaceStrategyExcel01Actions.pickFaceStrategyExcel01UploadLoading(true));

    const app = yield select(getAppStore);

    const getData = {};

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `pickFaceStrategy/downloadProcess/PICK_FACE_STRATEGY_EXCEL_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'PICK_FACE_STRATEGY_EXCEL_01.XLSX');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PickFaceStrategyExcel01Actions.pickFaceStrategyExcel01UploadLoading(false));
  }
}

export const saga = [
  takeLatest(
    PickFaceStrategyExcel01Types.PICK_FACE_STRATEGY_EXCEL01_SHOW_BATCH_JOB_STATUS,
    pickFaceStrategyExcel01ShowBatchJobStatus
  ),
  takeLatest(
    PickFaceStrategyExcel01Types.PICK_FACE_STRATEGY_EXCEL01_UPLOAD_EXCEL,
    pickFaceStrategyExcel01UploadExcel
  ),
  takeLatest(
    PickFaceStrategyExcel01Types.PICK_FACE_STRATEGY_EXCEL01_DOWNLOAD_EXCEL,
    pickFaceStrategyExcel01DownloadExcel
  )
];
